import tw, { styled } from 'twin.macro'

export const HeaderTextWrapper = styled.div`
  ${tw`text-white flex flex-col`}

  h1 {
    ${tw`text-4xl text-left mb-6 mt-16`}
  }

  h2 {
    ${tw`text-2xl text-left mb-10`}
  }
`
